import { useState, type MouseEvent } from 'react';
import IconButton from '@mui/material/IconButton';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

/** MyHours-ADR-0014/D-75: kurze Modul-Erklärung je Seite, per Klick (nicht Hover, funktioniert auch auf Touch-Geräten). */
export function PageHelp({ text }: { text: string }) {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  function handleOpen(e: MouseEvent<HTMLElement>) {
    setAnchorEl(e.currentTarget);
  }

  return (
    <>
      <IconButton size="small" onClick={handleOpen} aria-label="Hilfe zu diesem Modul">
        <InfoOutlinedIcon fontSize="small" />
      </IconButton>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      >
        <Typography variant="body2" sx={{ p: 2, maxWidth: 320 }}>
          {text}
        </Typography>
      </Popover>
    </>
  );
}
